export enum HeroesVersion {
  Unknown = 0,
  Heroes3 = 3,
  Heroes5 = 5,
}
